import {
  BUTTON_SIZE_LG,
  BUTTON_SIZE_MD,
  BUTTON_SIZE_SM,
  BUTTON_VARIANT_DANGER,
  BUTTON_VARIANT_NEGATIVE,
  BUTTON_VARIANT_NEUTRAL,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY
} from './Button.constants'

import tokens from '../../design/design-tokens/tokens'

const tokensSize = size => {
  switch (size) {
    case BUTTON_SIZE_SM:
      return 'small'
    case BUTTON_SIZE_MD:
      return 'medium'
    case BUTTON_SIZE_LG:
      return 'large'
    default:
      return 'medium'
  }
}

const tokensVariant = variant => {
  switch (variant) {
    case BUTTON_VARIANT_PRIMARY:
      return BUTTON_VARIANT_PRIMARY
    case BUTTON_VARIANT_SECONDARY:
      return BUTTON_VARIANT_SECONDARY
    case BUTTON_VARIANT_NEUTRAL:
      return BUTTON_VARIANT_NEUTRAL
    case BUTTON_VARIANT_DANGER:
      return BUTTON_VARIANT_DANGER
    case BUTTON_VARIANT_NEGATIVE:
      return BUTTON_VARIANT_NEGATIVE
    default:
      return BUTTON_VARIANT_PRIMARY
  }
}

export const styles = (
  kind = BUTTON_VARIANT_PRIMARY,
  size = BUTTON_SIZE_MD
) => {
  return `
    display: inline-flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
    float: right;
    transition-property: background-color, border-color, color;
    transition-duration: 0.3s;
    transition-timing-function: ease;
    border-style: solid;
    color: ${tokens.Button[tokensVariant(kind)].textColor};
    background-color: ${tokens.Button[tokensVariant(kind)].backgroundColor};
    text-align: ${tokens.Button[tokensVariant(kind)].textAlign};
    border-width: ${tokens.Button[tokensVariant(kind)].borderWidth};
    border-color: ${tokens.Button[tokensVariant(kind)].borderColor};
    border-radius: ${tokens.Button[tokensVariant(kind)].borderRadius};
    outline: ${tokens.Button[tokensVariant(kind)].outline};
    cursor: ${tokens.Button[tokensVariant(kind)].cursor};
    font-weight: ${tokens.Button[tokensVariant(kind)].typography.fontWeight};
    letter-spacing: ${tokens.Button[tokensVariant(kind)].typography.letterSpacing
    };
    font-family: ${tokens.Button[tokensVariant(kind)].typography.fontFamily};
    text-transform: ${tokens.Button[tokensVariant(kind)].typography.textCase};
    text-decoration: ${tokens.Button[tokensVariant(kind)].typography.textDecoration
    };
    width: ${tokens.Button.size[tokensSize(size)].width};
    min-width: ${tokens.Button.size[tokensSize(size)].minWidth};
    height: ${tokens.Button.size[tokensSize(size)].height};
    font-size: ${tokens.Button.size[tokensSize(size)].typography.fontSize};
    line-height: ${tokens.Button.size[tokensSize(size)].typography.lineHeight};
    padding: ${tokens.Button.size[tokensSize(size)].paddingTop} ${tokens.Button.size[tokensSize(size)].paddingLeft
    };

  &:hover,
  &:active {
    background-color: ${tokens.Button[`${tokensVariant(kind)}_hover`].backgroundColor
    };
    color: ${tokens.Button[`${tokensVariant(kind)}_hover`].textColor};
    border-color: ${tokens.Button[`${tokensVariant(kind)}_hover`].borderColor};
  }
  
  &__icon {
    margin-left: 5px;
  }
  & > span {
    pointer-events: none;
  }
`
}

export const disabledStyles = (kind = BUTTON_VARIANT_PRIMARY) => {
  return `
  background-color: ${tokens.Button[`${tokensVariant(kind)}_disabled`].backgroundColor
    };
  color: ${tokens.Button[`${tokensVariant(kind)}_disabled`].textColor};
  border-color: ${tokens.Button[`${tokensVariant(kind)}_disabled`].borderColor};
  cursor: ${tokens.Button[`${tokensVariant(kind)}_disabled`].cursor};

  &:hover,
  &:active {
    background-color: ${tokens.Button[`${tokensVariant(kind)}_disabled`].backgroundColor
    };
    color: ${tokens.Button[`${tokensVariant(kind)}_disabled`].textColor};
    border-color: ${tokens.Button[`${tokensVariant(kind)}_disabled`].borderColor
    };
    cursor: ${tokens.Button[`${tokensVariant(kind)}_disabled`].cursor};
  }
`
}
